module.exports = __webpack_public_path__ + "static/PatKT-03-39c5ae9575eabf3023f1961bfe4a924f.jpg";